function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 62.149,
  y1: 20.335,
  x2: 172,
  y2: 20.335
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 3,
  y1: 20.335,
  x2: 23.418,
  y2: 20.335
});

var _ref4 =
/*#__PURE__*/
React.createElement("ellipse", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  cx: 42.784,
  cy: 20.336,
  rx: 19.366,
  ry: 17.336
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 151.305,
  y1: 74.279,
  x2: 171.998,
  y2: 74.279
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 3,
  y1: 74.279,
  x2: 112.573,
  y2: 74.279
});

var _ref7 =
/*#__PURE__*/
React.createElement("ellipse", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  cx: 131.938,
  cy: 74.279,
  rx: 19.366,
  ry: 17.336
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 99.674,
  y1: 128.265,
  x2: 172,
  y2: 128.265
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 3,
  y1: 128.265,
  x2: 60.941,
  y2: 128.265
});

var _ref10 =
/*#__PURE__*/
React.createElement("ellipse", {
  fill: "none",
  stroke: "#595B5A",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  cx: 80.308,
  cy: 128.265,
  rx: 19.366,
  ry: 17.337
});

var SvgServizi = function SvgServizi(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 176,
    height: 149,
    viewBox: "-0.986 -0.106 176 149",
    enableBackground: "new -0.986 -0.106 176 149",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgServizi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/servizi.ca9921a0.svg";
export { ForwardRef as ReactComponent };